import styled from 'styled-components'
import { Pill } from '@components/Pill'

export const CountChipEl = styled(Pill).attrs({ $tone: 'muted' as const })`
	flex-shrink: 0;
`
